document.addEventListener('DOMContentLoaded', ()=>{
    
    changeBreadCrumbTitle();

	
    if(isChallengePage()) {
      prepareContactPage();
      setTimeout(()=>{
        window.scroll({top: 0, left: 0, behavior: 'smooth'});
      }, 5)
    } else {
      scrollToAnchor();
    }


    setTimeout(()=>{
      let lang = document.querySelector("html").lang;
      translatePrices(lang);
      attachObserver();
    },2000);
    
});



function isChallengePage() {
  return window.location.href.indexOf("challenge") != -1
}

function prepareContactPage() {
   let content = document.getElementsByClassName("shopify-challenge__container")[0];
   content.style.margin = "160px auto";
}

function translateSelectFields(lang) {
  let selectOptions = document.querySelectorAll('.single-option-selector')[0];

  const strSize_tr = "(Çerçeve Dahil)";
  const strSize_en = "(Frame Included)";

  if(lang === 'en') {
    for(let i of selectOptions) { i.textContent = i.textContent.replace(strSize_tr, strSize_en) };
  } else if(lang === 'tr'){
    for(let i of selectOptions) { i.textContent = i.textContent.replace(strSize_en, strSize_tr) };
  }


}

function attachObserver() {
  // Select the node that will be observed for mutations
  const targetNode = document.querySelector('html');

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: false, subtree: false };

  // Callback function to execute when mutations are observed
  const callback = function(mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for(let mutation of mutationsList) {
        let lang = mutation.target.lang;
        translatePrices(lang);
        translateSelectFields(lang);
      }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
}


function translateDefaultPrices(lang) {
  let editions = document.querySelectorAll(".price .prod-price:first-child em");
  let prices = document.querySelectorAll(".price .prod-price:last-child");

  if(lang === 'en') {

    editions.forEach((edition)=>{
      let editionNumber = edition.getElementsByClassName('c-edition')[0];
      
      edition.innerHTML = "";
      edition.append(editionNumber);
      edition.append(" Editions");
    });

    prices.forEach((price)=>{
      let priceNumber = price.getElementsByClassName("c-price")[0];
      
      price.innerHTML = "";
      price.append("Starting at ");
      price.append(priceNumber);
    });
  } else if(lang === 'tr') {
    
    editions.forEach((edition)=>{
      let editionNumber = edition.getElementsByClassName('c-edition')[0];
      edition.innerHTML = "";
      edition.append(editionNumber);
      edition.append(" Edisyon");
    });

    prices.forEach((price)=>{
      let priceNumber = price.getElementsByClassName("c-price")[0];
      
      price.innerHTML = "";
      price.append(priceNumber);
      price.append("\'den başlayan");
    });
  }
}

function translateWallPrices(lang) {
  let discountFields = document.querySelectorAll('.price .prod-price');

  if(lang === 'en') {
    discountFields.forEach(df => {
      let discountAmount = df.querySelector('.c-discount');
      let price = df.querySelector('.c-price');

      df.innerHTML = "";
      df.append(price);
      df.append(" (");
      df.append(discountAmount);
      df.append("% Discount)");
    });
  } else if(lang === 'tr') {
    discountFields.forEach(df => {
      let discountAmount = df.querySelector('.c-discount');
      let price = df.querySelector('.c-price');

      df.innerHTML = "";
      df.append(price);
      df.append(" (%");
      df.append(discountAmount);
      df.append(" İndirim)");
    });
  }
}


function translatePrices(lang) {


  if(location.pathname.indexOf("walls-decorated-for-you-by-our-curators") != -1) {
    //walls

    translateWallPrices(lang);
    
  } else {
    //listing item

    translateDefaultPrices(lang);
  }

  
}

function changeBreadCrumbTitle() {
  var customBreadcrumbPageTitle = document.querySelector('#breadcrumb .page-title');
  if (customBreadcrumbPageTitle) {
    customBreadcrumbPageTitle.innerHTML = customBreadcrumbPageTitle.innerHTML.replace('Lovinart', 'LOVINART');
  }
}


function scrollToAnchor() {
    if(window.location.hash) {

        let anchorTop = $(window.location.hash).offset().top - 160;
        $('html, body').animate({
            scrollTop: anchorTop
          }, 500, function(){
            $('html, body').scrollTop(anchorTop)
          });
    } 
    
}